import { map } from 'rxjs';
import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { FeatureFlagQuery } from './state/feature-flag.query';
import { RoutesManager } from '../shared/models/routes.interfaces';
import { FeatureFlags } from '../api/models/profile/profile-feature-flags.enum';

export const GovTabsGuard: CanActivateFn = () => {
  const featureFlagQuery = inject(FeatureFlagQuery);
  const router = inject(Router);
  
  return featureFlagQuery.selectFlag(FeatureFlags.DoNotShowGovTabs).pipe(
    map(isOn => isOn ? router.parseUrl(`/${RoutesManager.pageNotFound}`) :true)
  );
};
